var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 10.308V14.6344C14.8838 14.8639 14.7927 15.084 14.6304 15.2463C14.4681 15.4086 14.248 15.4997 14.0185 15.4997H5.36532C5.13582 15.4997 4.91572 15.4086 4.75345 15.2463C4.59117 15.084 4.5 14.8639 4.5 14.6344V5.9815C4.5 5.75201 4.59117 5.53192 4.75345 5.36965C4.91572 5.20738 5.13582 5.11621 5.36532 5.11621H9.69191",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8037 4.5H15.3237V8.01989",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8835 4.94043L9.60352 9.78028",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellLaunch);
export default __webpack_public_path__ + "static/media/icn_table_cell_Launch.64a7440768f7d249468b4e107348406a.svg";
export { ForwardRef as ReactComponent };